import { render, staticRenderFns } from "./shipCompanySearch.vue?vue&type=template&id=37b4cd8d&scoped=true&"
import script from "./shipCompanySearch.vue?vue&type=script&lang=js&"
export * from "./shipCompanySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b4cd8d",
  null
  
)

export default component.exports